class HowHero extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.hero__slider-track');
    this.slides = this.querySelectorAll('.hero__slide');
    if (!this.track || this.slides.length < 2) return;

    this.index = 0;
    this.interval = Number(this.dataset.interval) || 5000;
    this.timer = null;
    this.dots = this.querySelectorAll('.hero__dot');

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.goTo(Number(dot.dataset.slide));
        this.start();
      });
    });

    this.update();
    this.start();
    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.stop();
      else this.start();
    });
  }

  disconnectedCallback() {
    this.stop();
  }

  start() {
    this.stop();
    this.timer = window.setInterval(() => this.next(), this.interval);
  }

  stop() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  next() {
    this.goTo((this.index + 1) % this.slides.length);
  }

  goTo(index) {
    if (index < 0 || index >= this.slides.length) return;
    this.index = index;
    this.update();
  }

  update() {
    this.track.style.transform = `translate3d(-${this.index * 100}%, 0, 0)`;
    this.slides.forEach((slide, i) => {
      slide.setAttribute('aria-hidden', i === this.index ? 'false' : 'true');
    });
    this.dots.forEach((dot, i) => {
      const isActive = i === this.index;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }
}

if (!customElements.get('how-hero')) {
  customElements.define('how-hero', HowHero);
}
